<template>
  <div class='en-container'>
    <div class="en-title">CHANEL KOREA YH</div>
    <div class="en-title" style="margin-bottom: 0.5rem;">Chanel.com's Terms of Use</div>

    <div class="en-article">
      <div class="article-title">▪ Article 1 (Purpose)</div>
      <div class="article-content">
        These Terms of Use (the "<strong>Terms of Use</strong>") are intended to set forth rights, obligations and responsibilities of Chanel’s official website operated by Chanel Korea YH ("<strong>Chanel.com</strong>") and the Users of all services provided by Chanel.com (the "<strong>Services</strong>").
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 2 (Definitions)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text"><strong>"Chanel.com"</strong> refers to the virtual business place set up by Chanel for transactions involving goods and services ("<strong>Goods</strong>") using telecommunication equipment such as computers in order to provide Goods to the User and, at the same time, refers to business entity that operates Chanel.com.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text"><strong>"User(s)"</strong> refers to either a Member or a Non-Member who accesses Chanel.com and uses the Services provided by Chanel.com in accordance with the Terms of Use.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text"><strong>"Member(s)"</strong> refers to a User who has registered for membership at Chanel.com and/or Chanel’s offline boutiques ("<strong>Boutique</strong>"), not merchants aiming for commercial sales, but users purchasing for personal use</div>
        </div>
        <div class="definition">
          <div class="definition-number">(4)</div>
          <div class="definition-text"><strong>"Non-Member(s)"</strong> refers to a User who uses the Services provided by Chanel.com without registering as a Member, not merchants aiming for commercial sales, but users purchasing for personal use</div>
        </div>
        <div class="definition">
          <div class="definition-number">(5)</div>
          <div class="definition-text"><strong>"Click-and-collect Order"</strong> refers to the method of order placement through Chanel.com where a User directly collects the purchased Goods at a Boutique rather than having the Goods delivered to the User.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 3 (Posting, Explaining and Amending the Terms of Use and Other Information) </div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Chanel.com shall post on its start page (entire page) the Terms of Use, company name, name of the representative, address of the business place (including the address of any organization that handles consumer complaints), telephone number, email address, business registration number, and mail order business number so that the User can easily check such information; provided that the Terms of Use may be accessed through a link.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Chanel.com shall provide a separate link or pop-up window that enables the User to understand certain key terms such as order cancellation, shipping information, and terms of refund as set forth in the Terms of Use prior to acceptance thereof.</div>
        </div>
        <div class="definition">
            <div class="definition-number">(3)</div>
            <div class="definition-text">Chanel.com may amend the Terms of Use to the extent that the amended Terms of Use are not in violation of the Act on Consumer Protection in Electronic Commerce, Etc., the Act on the Regulation of Terms and Conditions, the Framework Act on Electronic Transactions, the Digital Signature Act, the Act on Promotion of Information and Communications Network Utilization and Information Protection, Etc., the Framework Act on Consumers, and other applicable laws and regulations.</div>
        </div>
        <div class="definition">
            <div class="definition-number">(4)</div>
            <div class="definition-text">If Chanel.com amends the Terms of Use, it shall notify, via email or text message, the effective date of the amended Terms of Use and reasons for amendment, together with the Terms of Use currently in effect, beginning seven days prior to the effective date until the day immediately preceding such effective date.  If the Terms of Use are amended in a way that is unfavorable to the User, the amended Terms of Use shall be posted for at least 30 days before the effective date.  In such case, Chanel.com shall present a clear comparison between the Terms of Use currently in effect and the amended Terms of Use so that the difference(s) between the two are easily noticeable to the User.</div>
        </div>
        <div class="definition">
            <div class="definition-number">(5)</div>
            <div class="definition-text">Chanel.com’s notification of the amended Terms of Use will clearly notify that the User would be deemed to have accepted such amendment unless he/she indicates otherwise within a certain period of time. Accordingly, the User shall be deemed to have accepted the amended Terms of Use unless he/she indicates otherwise within the prescribed period. Even if the User does not accept the amended Terms of Use, Chanel.com must complete any purchase contract executed prior to the date the amended Terms of Use become effective.  Provided that, if the User does not accept the amended Terms of Use, Chanel.com may refuse to provide the Services on or after the date the amended Terms of Use become effective.</div>
        </div>
        <div class="definition">
            <div class="definition-number">(6)</div>
            <div class="definition-text">If Chanel.com amends the Terms of Use, the amended Terms of Use shall apply only to any contract to be executed on or after the date the amended Terms of Use become effective, and the Terms of Use prior to the amendment shall apply to any contract executed prior to the effective date of the amended Terms of Use; provided that, if the User who has already executed a contract notifies Chanel.com, and Chanel.com accepts, the User’s intention to be bound by the amended Terms of Use within the notice period of the amended Terms of Use set forth in Paragraph (4) of this Article, the amended Terms of Use shall apply.</div>
        </div>
        <div class="definition">
            <div class="definition-number">(7)</div>
            <div class="definition-text">Any matter not set forth herein and the interpretation hereof shall be in accordance with the Act on Consumer Protection in Electronic Commerce, Etc., the Act on the Regulation of Terms and Conditions, the Guideline on Consumer Protection in Electronic Commerce established by the Fair Trade Commission, other applicable laws and regulations, and generally accepted commercial customs and practices.</div>
        </div>
      </div> 
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 4 (Provision of and Modifications to the Services) </div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Chanel.com shall provide the following Services:</div>
        </div>
        <div class="follow-box">
          <div class="follow-box-item">
            <div class="follow-box-item-text"><span class="num">(i)</span>Provide information on Goods, etc., and execute purchase contracts; </div>
            <div class="follow-box-item-text"><span class="num">(ii)</span>Ship Goods pursuant to purchase contracts;</div>
            <div class="follow-box-item-text"><span class="num">(iii)</span>Provide customer support services via live chat;</div>
            <div class="follow-box-item-text"><span class="num">(iv)</span>Sync with Chanel Beauty and Fashion applications;</div>
            <div class="follow-box-item-text"><span class="num">(v)</span>Provide information on location based events and benefits based on location information of smartphone devices; and</div>
            <div class="follow-box-item-text"><span class="num">(vi)</span>Any other activities to be determined by Chanel.com.</div>
          </div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">If the description of the Services that Chanel.com has agreed to provide under the contract executed with the User is modified because Goods are sold out or their technical specifications have changed, Chanel.com shall immediately notify the User of the reason for the modification via an available method of contact.  Upon Chanel.com’s notice, the User may withdraw the purchase order or consent to modification of the contract.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 5 (Suspension of Services)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Chanel.com may temporarily suspend the Services under circumstances including but not limited to repair, inspection, replacement or breakdown of information and telecommunication equipment such as a computer or the loss of connection.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Unless otherwise specifically provided herein, the Services may be temporarily suspended in any of the events set forth in Paragraph (1) of this Article, and Chanel.com shall not be liable to compensate the User for any loss incurred in connection therewith, unless there is any willful misconduct or negligence on the part of Chanel.com.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">If the Services can no longer be provided due to reasons including but not limited to change of business type, abandonment of business, or merger or acquisition with another business, Chanel.com shall notify the User in a manner set forth in Article 8 hereof.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 6 (Membership Registration)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">The User may register as a Member by entering his/her information in the manner prescribed by Chanel.com and indicating his/her consent to the Terms of Use.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Chanel.com shall register as a Member any User who applies for the membership in accordance with Paragraph (1) of this Article unless one of the following applies:</div>
        </div>
        <div class="follow-box">
          <div class="follow-box-item">
            <div class="follow-box-item-text"><span class="num">(i)</span>A person has been disqualified as a Member in accordance with Article 7(3) hereof; except for Members who obtain Chanel.com’s approval to re-apply as a Member after three years have elapsed since such Member lost his/her membership in accordance with Article 7(3);</div>
            <div class="follow-box-item-text"><span class="num">(ii)</span>The information entered during registration is false, incomplete, or includes errors;</div>
            <div class="follow-box-item-text"><span class="num">(iii)</span>A person is suspected to be in violation of the purchase and sales policy established by Chanel.com and fails to provide justification regarding the suspected violation when asked by Chanel.com, or fails to provide an explanation to Chanel.com’s satisfaction; or</div>
            <div class="follow-box-item-text"><span class="num">(iv)</span>A person’s registration as a Member is deemed to cause serious technical issues for Chanel.com because the registrant uses macro programs, etc.</div>
          </div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">A User under the age of 14 may not register as a Member, and is ineligible to use the Services provided by Chanel.com.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(4)</div>
          <div class="definition-text">Location based services for Chanel Code Membership is provided to those over 14 years of age and personal location information of children under the age of 14 is not used or provided.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(5)</div>
          <div class="definition-text">A Member shall, without delay, notify Chanel.com of any change in the membership information entered in accordance with Paragraph (1) of this Article, by changing his/her information saved in the My Account page or other means.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 7 (Withdrawal from Membership and Loss of Membership)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">A Member may request to withdraw his/her membership at any time, and upon such request, Chanel.com shall take steps to deregister the User as a Member.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">In the event a Member is found to have committed any of the following, Chanel.com shall be entitled to disqualify the Member.</div>
        </div>
        <div class="follow-box">
          <div class="follow-box-item">
            <div class="follow-box-item-text"><span class="num">(i)</span>If the Member has requested a refund on five or more occasions due to a “change of mind” within a year;</div>
            <div class="follow-box-item-text"><span class="num">(ii)</span>If the Member has made more than the permitted number of purchases, or the Member is otherwise making irregular purchases in order to circumvent the limit on the number of purchases;</div>
            <div class="follow-box-item-text"><span class="num">(iii)</span>If the Member has entered false information when registering as a Member;</div>
            <div class="follow-box-item-text"><span class="num">(iv)</span>If the Member interferes with another User’s use of Chanel.com, appropriates information belonging to another User, or otherwise harms the order of electronic commerce;</div>
            <div class="follow-box-item-text"><span class="num">(v)</span>If the Member acts in violation of the laws and regulations, the Terms of Use or Chanel’s policies in connection with his/her use of Chanel.com;</div>
            <div class="follow-box-item-text"><span class="num">(vi)</span>If the Member illegally uses another person’s identity; or</div>
            <div class="follow-box-item-text"><span class="num">(vii)</span>If the Member has otherwise failed to qualify for the member eligibility policy established by Chanel.com.</div>
          </div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">If there is cause to revoke a Member’s membership, Chanel.com shall inform the Member and grant the Member a period of at least seven days to provide an explanation. If the Member fails to provide an explanation or Chanel.com determines that the explanation does not justify maintaining the membership, Chanel.com may cancel the membership.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 8 (Notices to Users)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Chanel.com may send notices to Members to the contact information entered at the time of registration or updated contact information.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">If notice will be provided to an unspecified number of Members (i.e., a large group of Members), Chanel.com may post the notice online for a period of at least a week within Chanel.com in lieu of sending notices to individual Members; provided that, any matter that has a material impact on the transaction executed by a Member shall be notified to such Member individually in accordance with Paragraph 1 of this Article.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 9 (Purchase Orders)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-text">The User shall place an order for Goods on Chanel.com in the order described below or other similar sequence. Chanel.com shall provide information relating to each step in a way that is easily understandable to the Users. Members may undergo a simplified process (e.g., use the information provided at the time of registration for information pertaining to Subparagraphs (ii) and (iv) and use of a link to complete Subparagraph (iii)):</div>
        </div>
        <div class="follow-box">
          <div class="follow-box-item">
            <div class="follow-box-item-text"><span class="num">(i)</span>Searching and selecting Goods;</div>
            <div class="follow-box-item-text"><span class="num">(ii)</span>Entering the name, address, telephone number (or mobile phone number), email address, etc.;</div>
            <div class="follow-box-item-text"><span class="num">(iii)</span>Reviewing the Terms of Use, the Services for which an order cannot be cancelled, and shipping fees and other costs;</div>
            <div class="follow-box-item-text"><span class="num">(iv)</span>Accepting the Terms of Use and confirming or declining Subparagraph (iii) above;</div>
            <div class="follow-box-item-text"><span class="num">(v)</span>Placing an order for purchase of Goods, confirming the purchase order, or giving consent to Chanel.com’s confirmation of the purchase order; and</div>
            <div class="follow-box-item-text"><span class="num">(vi)</span>Selecting the payment method.</div>
          </div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 10 (Execution of a Purchase Contract)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">The purchase contract is validly executed when an order placed by User has been confirmed by Chanel.com, and notice of such confirmation is received by the User in the form of notice provided in Article 12(1).</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Chanel.com’s “confirmation of the purchase order” shall include confirmation of the User’s purchase order, whether the Goods ordered are available for sale, and information on modifications to or cancellation of the purchase order.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">Chanel.com may cancel any purchase order in the event of one of the following:</div>
        </div>
        <div class="follow-box">
          <div class="follow-box-item">
            <div class="follow-box-item-text"><span class="num">(i)</span>The order contains false or incomplete information, or errors;</div>
            <div class="follow-box-item-text"><span class="num">(ii)</span>Orders by person other than Users as defined in Article 2;</div>
            <div class="follow-box-item-text"><span class="num">(iii)</span>Four or more quantities of a single product are purchased using a single ID on the same day;</div>
            <div class="follow-box-item-text"><span class="num">(iv)</span>There is insufficient stock of the ordered Goods; or</div>
            <div class="follow-box-item-text"><span class="num">(v)</span>Confirming a purchase order causes serious technical issues for Chanel.com because the User, for example, uses macro programs.</div>
          </div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 11 (Pricing Policy and Payment Method)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Payment for Goods purchased at Chanel.com may be made through any of the methods below. Chanel.com shall not charge any fees corresponding to any payment method in addition to the total price charged for the purchase of Goods.</div>
        </div>
        <div class="follow-box">
          <div class="follow-box-item">
            <div class="follow-box-item-text"><span class="num">(i)</span>Wire transfer funds, including but not limited to using internet banking services;</div>
            <div class="follow-box-item-text"><span class="num">(ii)</span>Debit, credit or other cards;</div>
            <div class="follow-box-item-text"><span class="num">(iii)</span>Micropayment using mobile phones;</div>
            <div class="follow-box-item-text"><span class="num">(iv)</span>Easy pay solutions services; or</div>
            <div class="follow-box-item-text"><span class="num">(v)</span>Other electronic payment method.</div>
          </div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Chanel.com shall use its best efforts to ensure that the prices displayed on the website are accurate. However, if the price of Goods already purchased by User is not correct, Chanel.com will contact the User by email, telephone or other means and ask whether the order should be placed at the correct price or canceled. If the User cannot be contacted within twenty-four hours, the order will be cancelled.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">In accordance with applicable laws and regulations, User may ask Chanel.com to use an escrow to protect User’s payment.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 12 (Notice of Receipt; Modifying or Cancelling an Existing Order)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">After an order is placed, Chanel.com shall immediately provide notice of receipt to User.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">After receiving Chanel.com’s notice of receipt, the User may cancel the purchase order within a certain period (maximum 30 minutes) through the Chanel.com website if, for example, the products are not what the User ordered/intended to order.  Provided, however, if the purchase has been made through methods other than card payment under Article 11(1)(ii), or 30 minutes have lapsed after receiving Chanel.com’s notice of receipt even where the purchase has been made through card payment under Article 11(1)(ii), the User may cancel an order in accordance with Article 15.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">Notwithstanding anything to the contrary in Article 12(2) above, Click-and-collect Order shall be cancelled automatically if the Goods are not collected within 14 days from the date the Goods are available at the collection Boutique.  The collection Boutique and delivery method may not be changed after the payment has been made for the Click-and-collect Order.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 13 (Supply of Goods)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">In the absence of a separate agreement with the User on when Goods will be supplied, Chanel.com shall, within seven days of the request for purchase, take actions requisite for delivery, including but not limited to reserving orders and packing. Chanel.com shall take actions necessary for product delivery within three business days if the User has already paid all or part of the price of Goods.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Chanel.com shall take actions necessary to enable the User to check the process and progress of the supply of Goods.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">Chanel.com shall clearly indicate the type of shipping, who is responsible for the shipping fees, and the expected time of arrival for each product purchased by the User.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 14 (Refunds)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-text">Notwithstanding the valid execution of the purchase contract pursuant to Article 10, Chanel.com may restrict the sale of Goods depending on availability of stock. If Chanel.com is unable to ship or supply Goods that have been ordered due to shortage or sellout, Chanel.com shall without delay inform the User of the order cancellation. If the User’s payment has already been processed, Chanel Online Store shall provide a refund, or take necessary actions to refund the payment for Goods, within three business days following receipt of payment.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 15 (Order Cancellation)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Any User who entered into a contract with Chanel.com for purchase of Goods may cancel the purchase order within seven days of the delivery.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Notwithstanding Paragraph (1) of this Article, the User may not return Goods or receive a refund following the delivery of Goods in the event of any of the following:</div>
        </div>
        <div class="follow-box">
          <div class="follow-box-item">
            <div class="follow-box-item-text"><span class="num">(i)</span>Goods are lost, damaged or destroyed due to any cause attributable to the User (including cases where the box containing the Goods or packaging of the Goods has been opened and it is no longer possible to resell the Goods incurring additional packaging fees, except in cases where the delivery box was destroyed or the Goods were defective when received by the User);</div>
            <div class="follow-box-item-text"><span class="num">(ii)</span>The value of Goods is substantially reduced due to use or consumption by the User;</div>
            <div class="follow-box-item-text"><span class="num">(iii)</span>The value of Goods is substantially reduced to the point it is difficult to resell due to the passage of time;</div>
            <div class="follow-box-item-text"><span class="num">(iv)</span>If the returned product(s) is not the actual Goods that was initially ordered;</div>
            <div class="follow-box-item-text"><span class="num">(v)</span>Permitting the User to cancel the order may result in irreparable damage to Chanel.com, and the User has already been informed of such fact and gave consent;</div>
            <div class="follow-box-item-text"><span class="num">(vi)</span>Gift with purchase, samples, or packaging that includes the Chanel logo delivered together with Goods are not returned; or</div>
            <div class="follow-box-item-text"><span class="num">(vii)</span>Chanel.com will not refund the cost of gift wrapping services.</div>
          </div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">With respect to Subparagraphs (ii) through (vi) of Paragraph (2) above, if Chanel.com did not take measures including but not limited to clearly indicating or explaining the limitations on cancelling orders so that it is readily accessible to the consumer, the limitations on cancelling orders will not apply and User may cancel his/her order.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(4)</div>
          <div class="definition-text">Click-and-collect Orders may be withdrawn in the same way as other Ordered Goods and may not be exchanged or refunded at the collection Boutique.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(5)</div>
          <div class="definition-text">Notwithstanding Paragraphs (1) and (2) of this Article, if the Goods are not as represented or advertised or inconsistent with the terms and conditions of the contract, the User may cancel the order within three months from the date of delivery of the Goods.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 16 (Effect of Cancellation)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">If Goods are returned from the User, Chanel.com shall, within three business days from the date of return, refund any payments for Goods; provided that, processing times may vary depending on the method of payment. If Chanel.com is responsible for any delays to refunds, Chanel.com shall pay late interest to the User calculated by multiplying the late interest rate determined and published by the Korea Fair Trade Commission by the period of delay.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">If the User has paid for Goods by credit card, electronic currency or similar payment methods, Chanel.com shall, in performing Paragraph (1), request the payment processor (e.g., credit card company) to immediately stop or cancel the invoice of the payment for Goods.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">If an order is cancelled, the User shall be responsible for the costs to return the Goods; provided that, if User cancels an order because the Goods are not as pictured, represented or advertised, or there is a discrepancy in the terms and conditions of the contract, Chanel.com shall pay the cost of return. Chanel.com shall not charge a penalty or claim damages against the User for cancelling an order.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(4)</div>
          <div class="definition-text">If an order is cancelled, return of the Goods shall only be processed by shipping companies designated by Chanel. If the User returns the Goods via a different shipping company, despite Chanel’s guidance on designated shipping companies, Chanel.com will not bear the costs of the return and is not liable for any damage or loss that occurred during the shipment.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(5)</div>
          <div class="definition-text">If the User has paid the shipping fee when purchasing the Goods, Chanel.com shall clearly indicate who bears the return shipping fee in case the order is cancelled in a manner that is easily understandable to the User.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(6)</div>
          <div class="definition-text">The shipping fee and return shipping fee by shipping option is as follows.</div>
        </div>
        <div class="follow-box">
          <div class="follow-box-item">
            <div class="follow-box-item-text"><span class="num">(i)</span>Regular Shipping: KRW 2,500. Shipping is free of charge for purchases exceeding KRW 30,000.</div>
            <div class="follow-box-item-text"><span class="num">(ii)</span>Next-day or designated day shipping: KRW 3,500 (paid service)</div>
            <div class="follow-box-item-text"><span class="num">(iii)</span>Return shipping fee (borne by the User if returning due to a “change of mind”): KRW 5,000 (Additional cost will be incurred for delivery to remote locations such as islands or mountain regions)</div>
          </div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 17 (Product Ratings, etc.)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Only Users who actually purchased items at Chanel.com may provide the product ratings. Users shall prepare Product Ratings, etc., based on honest opinions and experiences without receiving any consideration or benefit.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">The product ratings prepared by Users shall be approved by Chanel.com before they are posted publicly. Chanel.com reserves the right to determine whether the product ratings drafted by Users comply with Chanel.com’s guidelines.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">Chanel.com may restrict the posting of product ratings if it is not factually accurate and may cause misinterpretation or other damages to other Users, Chanel, or Chanel’s brand.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(4)</div>
          <div class="definition-text">Chanel.com may restrict the posting of product ratings if sensitive information, as defined in Article 23, Paragraph 1 of the Personal Information Protection Act (“Sensitive Information”), included in the product ratings may cause harm to other Users.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(5)</div>
          <div class="definition-text">Chanel.com may restrict the posting of product ratings if the contents of the product rating differs from the actual conditions of product use, and may cause misunderstanding or other damages to other Users, Chanel, or Chanel’s brand.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(6)</div>
          <div class="definition-text">Chanel.com shall not respond to a published product rating and may reach out directly to customers before posting the product rating or after making the product rating non-public in case the product rating can be resolved on or responded.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(7)</div>
          <div class="definition-text">Chanel.com shall not require employees to produce product ratings and shall make reasonable efforts not to publish product ratings by employees or known brand-related personnel.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(8)</div>
          <div class="definition-text">If Chanel.com wishes to use and display, in whole or in part, the product ratings, questions, comments, conversations, etc. that Users draft on Chanel.com (the “Product Ratings, etc.”) for marketing purposes, it shall obtain the User’s consent. Within the scope consented by the user, Chanel.com may also display the User’s name or other materials on the Product Ratings, etc., and may modify expressions, lengths, etc., to the extent that the overall meaning is not changed. If a User finds the use of their Product Ratings, etc., inappropriate or beyond the agreed scope and purpose, he may submit his opinion to Chanel.com via email or other means, and Chanel.com have in place appropriate procedures to enable such communication.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(9)</div>
          <div class="definition-text">Chanel.com shall treat all Product Ratings, etc., drafted by Users equally but shall not post the same if Product Ratings, etc., include any of the following:</div>
        </div>
        <div class="follow-box">
          <div class="follow-box-item">
            <div class="follow-box-item-text"><span class="num">(i)</span>Content that is not suitable for Chanel.com used by the public, such as obscene, discriminatory expressions (including content that encourages racial discrimination, hatred, physical harm, violence), profanity, etc.;</div>
            <div class="follow-box-item-text"><span class="num">(ii)</span>Advertising, spam content, content displaying products, offers, or websites that are unrelated to or different from Chanel.com’s products and Services;</div>
            <div class="follow-box-item-text"><span class="num">(iii)</span>Materials that Users do not own, infringe on other rights or fail to secure legitimate rights;</div>
            <div class="follow-box-item-text"><span class="num">(iv)</span>Details on services or logistics unrelated to the products purchased by Users;</div>
            <div class="follow-box-item-text"><span class="num">(v)</span>Email address, URL (excluding Chanel.com), telephone number, address, or other contact information;</div>
            <div class="follow-box-item-text"><span class="num">(vi)</span>Content that defames, abuses, disparages, blindly criticizes, or slanders Chanel.com, other persons, or entities;</div>
            <div class="follow-box-item-text"><span class="num">(vii)</span>Comments or unclear content on medical conditions or effects; or</div>
            <div class="follow-box-item-text"><span class="num">(viii)</span>Content that is fraudulent, deceptive, misleading, unlawful, or promotes illegal activities.</div>
          </div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 18 (Obligations of Chanel.com)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Chanel.com shall not engage in any act prohibited by law or the Terms of Use, and shall use its best efforts to ensure the continuous and stable supply of Goods.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Chanel.com shall establish a security system to protect the User’s personal data (including the User’s financial information) so that the User can use the internet services in a safe and secure manner.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">Chanel.com shall be liable to compensate the User for any loss incurred in the use of the Services caused by Chanel.com’s intentional or gross negligence; provided, however, Chanel.com shall not be liable for damage to personal data, abnormalities to the Services, or disputes concerning postings made by Users arising out of (a) unforeseeable accidents (e.g., hacking) related to inherent risks in the network that are not attributable to any fault of Chanel.com that occurred despite technical, security and other measures, or (b) natural disasters.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(4)</div>
          <div class="definition-text">Chanel.com shall be liable to compensate the User for any loss incurred due to Chanel.com’s unfair labeling or advertising of Goods as defined in Article 3 of the Act on Fair Labeling and Advertising.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(5)</div>
          <div class="definition-text">Chanel.com may send Members marketing information including but not limited to emails, text messages, letters or other information only if the Member has previously agreed to receive such information.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 19 (Privacy Policy)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Chanel.com shall collect User’s personal data only to the extent necessary for the provision of the Services.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">In collecting a User’s personal data, Chanel.com shall inform the User of the purpose of collection and use, and obtain consent thereto from the User.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">Unless permitted under applicable laws and regulations, Chanel.com shall not use the personal data collected for purposes other than the stated purposes and shall inform the User of new purpose of use, if any, or provision of personal data to a third party and obtain consent thereto from the User when using or providing the data.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(4)</div>
          <div class="definition-text">When obtaining User consent in accordance with Paragraph (2) or (3) above, Chanel.com shall notify the purpose of collection and use of the personal data, information on the provision of data to a third party (including the person receiving the data, purpose of use by the receiving party, and types of personal data to be provided) and other matters set forth in Article 22 of the Act on Promotion of Information and Communications Network Utilization and Information Protection, Etc., to the User. The User may withdraw his/her consent at any time.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(5)</div>
          <div class="definition-text">Users may, at any time, request access to, or request for a correction of his/her personal data that he/she provided to Chanel.com. Upon receiving a request to correct information that cannot be corrected by the User through the My Account page, Chanel.com shall without delay take necessary actions.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(6)</div>
          <div class="definition-text">Chanel.com shall keep the number of managers with access to personal data at a minimum necessary for the protection of personal data, and be solely responsible for any loss incurred by the User due to the loss, leakage, or alteration of the User’s personal data, including credit card and bank account information, provided that the loss is attributable to Chanel.com.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(7)</div>
          <div class="definition-text">Chanel.com or any third party(ies) that receives personal data from Chanel.com shall destroy the personal data when the purpose of collection and provision to a third party is achieved, unless stipulated otherwise in applicable laws and regulations.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(8)</div>
          <div class="definition-text">Chanel.com may, with prior consent from a Member, use the Member’s personally identifiable data in customized services, e-commerce, community, content, and mobile services for purposes of quantitative and qualitative improvement. The Member may, at any time indicate his/her refusal to receive marketing and E-DM messages from Chanel.com, and Chanel.com shall promptly register the refusal with its internal system to minimize any inconvenience to the Member.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(9)</div>
          <div class="definition-text">Users must specifically tick the check box indicating his/her consent to the collection, use and provision of personal data (i.e., Chanel.com shall not set up the system so that the User must untick the check boxes). Chanel.com shall specifically list the Services that are unavailable if the User does not consent to the collection, use and provision of personal data. Chanel.com shall not limit or refuse to provide the Services, including membership registration because the User did not consent to optional collection, use and provision of personal data (i.e., non-required items).</div>
        </div>
        <div class="definition">
          <div class="definition-number">(10)</div>
          <div class="definition-text">Members may, at any time and at his/her discretion, withdraw his/her consent to the collection and use of personal data given to Chanel.com, by withdrawing from membership.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(11)</div>
          <div class="definition-text">Detailed information on processing of personal data is available in the privacy policy.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 19-2 (Use or Provision of Personal Location Information)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Where Chanel.com wishes to provide services based on personal location information, it shall expressly state so in the Terms of Use and obtain prior consent of personal location data subjects.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Chanel.com shall not provide personal location information without consent of personal location data subjects. Where it provides personal location information to a third party, it shall notify the users of the third party recipients and the purposes of such provision before it does so and obtain their consent.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">Where Chanel.com provides personal location information of personal location data subjects to a third party designated by the personal location data subjects, it shall immediately notify the personal location data subjects of the recipient, the date and time, and purpose of the provision every time it provides personal location information of personal location data subjects to the third party, or notify the personal location data subjects of such information regarding a certain number of such provisions with the data subjects’ consent.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 19-3 (Retaining Records of Use and Provision of Personal Location Information)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Chanel.com automatically keeps records of using and providing of personal location information on its location information system and retains such records for at least 6 months. However, where a personal location data subject withdraws his/her consent for use or provision of his/her personal location information, the records of using and providing of the relevant personal location information shall be destroyed.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 19-4 (Rights of Data Subjects and Method of Exercising Such Rights)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Personal location data subjects may at any time withdraw his/her consent for using or providing his/her personal location information, either wholly or partially. Personal location data subjects may at any time request temporary suspension of using or providing his/her personal location information. However, either prat or whole of the Services may be either partially or wholly suspended.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Personal location data subjects may request to view or be informed of the records of using and providing of his/her personal location information or where his/her personal location information has been provided to a third party under the Act on the Protection, Use, etc. of Location Information or another statute, the reasons and details thereof. Where there is an error in the records or information, personal location data subjects may request correction.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">Personal location data subjects may exercise their rights listed in the above provisions by contacting the customer center (Fragrance and Beauty Product : 080-805-9638, Fashion and Watch & Fine Jewelry: 080-805-9628, customer.service@chanel.co.kr).</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 19-5 (Purpose of Processing Personal Location Information and Retention Period)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Chanel.com retains personal location information to provide Chanel.com’s location-based services and to comply with relevant laws and regulations, and for the purposes to which the personal location data subjects consented.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Chanel.com uses such personal location information only for the period as necessary to achieve the purposes set forth in Paragraph (1) of this Article. Where it is required to retain certain personal location information under relevant laws and regulations, Chanel.com retains the information for the periods prescribed under the law and regulations and never uses such information for any purposes other than the purposes described above.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 20 (Member Obligations related to ID and Password)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">Members are responsible for the management of his/her ID and password, except as provided under applicable laws, privacy policy, and Article 18 of the Terms of Use.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(4)</div>
          <div class="definition-text">Members shall not permit a third party to use the Member’s ID or password.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(5)</div>
          <div class="definition-text">Members shall immediately notify Chanel.com of his/her ID or password being stolen or used by a third party and follow the instructions of Chanel.com.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(6)</div>
          <div class="definition-text">If a User does not comply with the obligations in the Terms of Use, Chanel.com may restrict the User’s use of his/her account and the Services.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 21 (User Obligations)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Users shall not engage in any of the following:</div>
        </div>
        <div class="follow-box">
          <div class="follow-box-item">
            <div class="follow-box-item-text"><span class="num">(i)</span>Entering false information when registering, including in the application for membership or changes to the User’s account information;</div>
            <div class="follow-box-item-text"><span class="num">(ii)</span>Creating multiple IDs;</div>
            <div class="follow-box-item-text"><span class="num">(iii)</span>Unauthorized use or leakage of others’ personal data;</div>
            <div class="follow-box-item-text"><span class="num">(iv)</span>Orders not in compliance with the eligibility of Users provided in Article 2;</div>
            <div class="follow-box-item-text"><span class="num">(v)</span>Modifying information posted on Chanel.com;</div>
            <div class="follow-box-item-text"><span class="num">(vi)</span>Transmitting or posting information (including computer programs) other than as permitted by Chanel.com;</div>
            <div class="follow-box-item-text"><span class="num">(vii)</span>Infringing on copyright and other intellectual property rights of a third party including Chanel.com;</div>
            <div class="follow-box-item-text"><span class="num">(viii)</span>Defaming or interfering with a third party including Chanel.com;</div>
            <div class="follow-box-item-text"><span class="num">(ix)</span>Posting or writing obscene or violent messages, images, voice recordings or other information that is against public order and ethical standards. on Chanel.com’s Customer Help Section or the gift message form; or</div>
            <div class="follow-box-item-text"><span class="num">(x)</span>Purchasing Goods in contravention of Chanel’s purchase limit policy (four or more quantities of the same product on the same day).</div>
          </div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Chanel.com may hold the User liable for User’s actions under Paragraph (1), and Chanel.com shall not assume any responsibility.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 22 (CHANEL CODE)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Members who are citizens or residents of Korea who have purchased Chanel’s perfumes or cosmetic products may apply for the CHANEL CODE membership.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">The CHANEL CODE membership consists of levels denoted by five different colors. Depending on the level, different benefits such as new product samples, newsletter service, invitation to events, and private sessions and exclusive services are provided. The CHANEL CODE membership is designed to provide customized customer services, and does not provide economic benefits such as reward points or discounts.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">The CHANEL CODE membership level is valid for one year from the last date of purchase, and a member’s level is determined based on the number of visits and amount of purchases made in the past one-year period from the last date of purchase. The amount of purchases comprises the total amount of purchases made at Chanel.com, offline stores (including department stores and duty free stores), and department store online shopping malls*. (*Limited to certain stores in department store online shopping malls. Please contact the Customer Care Center to inquire which department store online shopping mall counts towards the total amount purchases made.)</div>
        </div>
        <div class="definition">
          <div class="definition-number">(4)</div>
          <div class="definition-text">If the eligibility requirements for a higher CHANEL CODE membership level is met during a given valid period, the membership level will be immediately upgraded (integrated into our system within 30 business days). Any membership upgrade may be cancelled if the Member later falls short of the requirements for membership upgrade due to product returns/refund and other reasons.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(5)</div>
          <div class="definition-text">If a Member does not make any purchases during the one-year period in which a membership level is valid, the Member shall be a ‘Welcome’ level member regardless of his/her previous membership level.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(6)</div>
          <div class="definition-text">The rights and service benefits of the CHANEL CODE membership may not be assigned or transferred to others.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(7)</div>
          <div class="definition-text">Location-based service of CHANEL CODE membership is provided free of charge. If fees are to be charged, the fact that these services are charged will be notified in advance, and services will be provided only to those who purchased such services.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(8)</div>
          <div class="definition-text">Details of the CHANEL CODE may be amended or terminated at any time due to changes in Chanel’s policy and/or to improve customer service.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 23 (CHANEL FASHION)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">This Article applies additionally to Users or Members who are registered on the CHANEL Fashion mobile application (“<strong>Fashion App</strong>”) and use the Fashion App.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Chanel retains all rights, ownership, and interests in the Fashion App, including the content and application (including content and applications on social networking websites). Chanel owns all copyrights for the materials on the Fashion App or has acquired valid rights from third parties to use the materials on the Fashion App. Furthermore, Chanel owns or has acquired valid rights from third parties to use all trademarks, service marks, trade names, logos, and domain names used on or in connection with the Fashion App. Any modification or use of the materials on the Fashion App for purposes not expressly permitted constitutes a violation of Chanel’s copyrights and other proprietary rights. Unless prior written consent is obtained from Chanel, no part of the Fashion App may be copied, reproduced, republished, uploaded, posted, transmitted, or distributed in any manner for purposes other than viewing. Acts such as framing any content on the Fashion App or unauthorized linking to it are also included in the prohibited activities.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">Chanel processes User’s personal data in accordance with the Chanel <a href="https://www.chanel.com/kr/privacy-policy/">privacy policy</a> and may provide the User with personalized services and brand communications.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(4)</div>
          <div class="definition-text">The other provisions of these Terms of Use apply to Chanel and Users within the scope of the services provided by the Fashion App.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 24 (Copyright and Restrictions on Use)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Chanel.com shall retain copyrights and intellectual property rights with respect to any works created by Chanel.com.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Users shall not reproduce, transmit, publish, broadcast, or otherwise use for profit, or permit a third party to use the information that are obtained through the use of Chanel.com and any intellectual property rights that are vested in Chanel.com without Chanel.com’s prior consent.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">Chanel.com shall inform Users of the use of copyrights contractually vested in the User.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 25 (Handling User Complaints)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Chanel.com shall have the Customer Care Center in place for Users’ convenience.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Chanel.com shall, as a matter of priority, address complaints or comments from Users. If Chanel.com is unable to address complaints or comments in a timely manner, Users shall be informed of the reason, and a schedule for when such complaint/comment will be handled.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(3)</div>
          <div class="definition-text">If the User files a petition for relief in an e-commerce dispute arising between Chanel.com and the User, the dispute may be resolved by a dispute resolution institution including but not limited to the Consumer Dispute Settlement Commission, the E-Commerce Mediation Committee, or other dispute resolution organizations organized and operated pursuant to applicable consumer protection laws and regulations.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(4)</div>
          <div class="definition-text">If a dispute relating to location information between Chanel.com and the data subject is not amicably concluded or the parties are unable to settle, the parties may apply for mediation to the Personal Information Dispute Mediation Committee in accordance with Personal Information Protection Act.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 26 (Jurisdiction and Governing Law)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Any dispute over an e-commerce transaction arising between Chanel.com and the User shall be finally settled by the district court having jurisdiction over the current address of the User or, if not available, the domicile of the User at the time the claim is filed, which is the court of first instance with exclusive jurisdiction. If the User’s current address or domicile is not clearly known at the time the claim is filed or the User resides overseas, the claim shall be filed with the competent court determined under the Civil Procedures Act.</div>
        </div>
        <div class="definition">
          <div class="definition-number">(2)</div>
          <div class="definition-text">Any claim over an e-commerce transaction arising between Chanel.com and the User shall be subject to the laws of the Republic of Korea.</div>
        </div>
      </div>
    </div>

    <div class="en-article">
      <div class="article-title">▪ Article 27 (Business Information)</div>
      <div class="article-content">
        <div class="definition">
          <div class="definition-number">(1)</div>
          <div class="definition-text">Business name, address and telephone number of Chanel.com are as follows.</div>
        </div>
      </div>

      <div class="table">
        <table>
          <tr>
            <td class="label">Business Name</td>
            <td class="content">Chanel Korea YH</td>
          </tr>
          <tr>
            <td class="label">Address</td>
            <td class="content">11F Pacific Tower, Sejongdaero 9-gil 41, Jung-Gu, Seoul</td>
          </tr>
          <tr>
            <td class="label">Telephone</td>
            <td class="content">
              Fragrance and Beauty Product: 080-805-9638,<br>
              Fashion and Watch & Fine Jewelry:080-805-9628
            </td>
          </tr>
          <tr>
            <td class="label">Location Information Manager</td>
            <td class="content">
              Technology & Digital Service team<br>
              Chief Privacy Officer<br>
              (privacy.korea@chanel.com)
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="bylaw">
      <div class="title">* Addenda</div>
      <div class="line-text">The Terms of Use shall become effective on October 4, 2018.</div>
      <div class="line-text">The amended Terms of Use shall become effective on June 1, 2019.</div>
      <div class="line-text">The amended Terms of Use shall become effective on September 7, 2021.</div>
      <div class="line-text">The amended Terms of Use shall become effective on April 28, 2023.</div>
      <div class="line-text">The amended Terms of Use shall become effective on November 29, 2023.</div>
      <div class="line-text">The amended Terms of Use shall become effective on February 3, 2025.</div>
    </div>
  </div>
</template>

<script>
import { setRemSize } from '@/utils/common'
export default {
  components: {},
    data() {
      return {

      };
    },
  computed: {},
  watch: {},
  mounted() {
    setRemSize();
    window.addEventListener('resize', this.setRemSize);
  },
  methods: {

  },
  beforeDestroy() {
    window.removeEventListener('resize', setRemSize);
  },
}
</script>
<style lang='scss' scoped>
.en-container {
  max-width: 100rem;
  margin: 0 auto;
  padding: 2rem;
  line-height: 2rem;
  color: #1D1D1D;
  box-sizing: border-box;
  div,span,ul,ol,li,tr,td,th{
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  }

  strong{
    font-weight: 600;
  }
  
  .en-title {
    font-size: 1.6rem;
    line-height: 2.8rem;
    text-align: center;
    font-weight: 600;
  }
  
  .en-article {
    line-height: 2rem;
    margin-bottom: 1rem;
    
    .article-title {
      font-size: 1.2rem;
      font-weight: bold;
      line-height: 2rem;
      margin-bottom: 0.5rem;
    }
    
    .article-content {
      font-size: 1.2rem;
      line-height: 2rem;
      padding-left: 1rem;
      
      .definition {
        display: flex;
        margin-bottom: 0.5rem;
        
        .definition-number {
          margin-right: 1rem;
          min-width: 2rem;
        }
        
        .definition-text {
          flex: 1;
        }
      }
    }
    
    .follow-box{
      padding-left: 3rem;
      margin-bottom: 0.5rem;
      .follow-box-item{
        .follow-box-item-text{
          display: flex;
        }
        .num{
          margin-right: 0.5rem;
          display: inline-block;
          min-width: 2rem;
        }
      }
    }
  }

  .table{
    margin-top: 1rem;
    table{
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #000;
      tr{
        border-bottom: 1px solid #000;
        &:last-child{
          border-bottom: none;
        }
        td{
          padding: 1rem;
          border-right: 1px solid #000;
          vertical-align: middle;
          text-align: center;
          font-weight: 600;
          &:last-child{
            border-right: none;
          }
          &.label{
            background-color: #B8B8FF;
            width: 30%;
          }
          &.content{
            background-color: #B8B8FF;
            width: 70%;
          }
        }
      }
    }
  }

  .bylaw{
    margin: 3.6rem 0 0.5rem;
  }
}
</style>